<template>
    <v-card class="co-novo-documento-signatario-card-dados-principais-observador pa-5">
        <v-card-text class="pa-0">
            <v-card-actions class="py-0">
                <email-signatario-novo
                    v-model="observador"
                    :signatarios-sugestoes="signatariosSugestoes"
                    campo-requerido
                    descricao
                />
                <v-spacer/>
                <v-btn icon @click="remover(observador)">
                    <v-icon size="22">mdi-delete</v-icon>
                </v-btn>
            </v-card-actions>
            <v-divider class="mt-3"/>
        </v-card-text>

        <div class="mt-3 py-0 px-2 d-flex observador-wrapper">
            <div class="d-flex align-center observador">
                <span class="observador-label">Definir como observador</span>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on" class="definir-ordem-tooltip">
                            <v-icon size="13px">mdi-information</v-icon>
                        </span>
                    </template>
                    <span>O e-mail informado não assinará o {{ $tc("pt_br.documento").toLowerCase() }}. Receberá apenas uma notificação quando o {{ $tc("pt_br.documento").toLowerCase() }} for formalizado.</span>
                </v-tooltip>
            </div>

            <v-switch
                class="ma-0 pa-0"
                color="primary"
                dense
                hide-details
                @change="alternarObservador"
                v-model="observador.observador"
            />
        </div>
    </v-card>
</template>

<script>
import EmailSignatarioNovo from '@/views/criar-documento/novo-documento-signatario/components/dados-principais/components/EmailSignatarioNovo'

export default {
    name: 'CardDadosPrincipaisObservador',
    components: {
        EmailSignatarioNovo
    },
    props: {
        observador: {
            required: true,
            type: Object
        },
        signatariosSugestoes: {
            type: Array,
        },
        posicaoSignatario: {
            type: Number
        }
    },
    methods: {
        alternarObservador() {
            this.$emit('alternar-observador', {posicaoSignatario: this.posicaoSignatario, observador: this.observador})
        },
        remover() {
            this.$emit('remover', {posicaoSignatario: this.posicaoSignatario})
        }
    }
}
</script>

<style lang="stylus">
.co-novo-documento-signatario-card-dados-principais-observador
    width 100%

    .dado-principal
        justify-content space-between

    .observador-wrapper
        justify-content space-between

        .observador
            gap 5px

            .observador-label
                color var(--text-color-300)
                font-size 14px

</style>
